module.exports = __webpack_public_path__ + "img/checkboxes.2bdfa203.svg";